import { useState, useEffect } from 'react';

export default function About() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    "https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/64c0e6b3bdf5014e0bb0115426615f72.jpeg",
    "https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/6531d0ba59902eecd1934284b997fcb6.jpeg",
    "https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/48ff7735a87481744486a487bf510d19.jpeg",
    "https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/8c9f4756ffebdfba192a81d57847cb79.jpeg",
    "https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/3b9af6b17fd5c0c2f8483b2b24341e3c.jpeg",
    "https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/fc4648fff444eaad95813c681740a168.jpeg",
    "https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/37fbf6f7a797bbbe620c7362fd004bbe.jpeg",
    "https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/efd85c188bead5600172de7d866fa000.jpeg"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section id="about" className="relative py-20 overflow-hidden border-t border-white/10">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fad050dbbc325a3ddcc420082ca74fd3.jpg"
          alt="Equipe Steel Importações"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-gray-900/85 to-black/90"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        {/* Text Content - Apenas Mobile */}
        <div className="md:hidden mb-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Nossa História
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed">
              Mais do que uma empresa, somos uma comunidade que acredita que importar não precisa ser complicado ou inacessível.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 md:p-10 shadow-2xl">
            <p className="text-lg text-gray-200 leading-relaxed mb-6">
              A <strong className="text-indigo-400">Steel Importações</strong> nasceu do desejo de ajudar pessoas como você a realizarem o sonho de ter acesso a produtos Apple com valores mais justos e uma maior personalização, vindo direto dos Estados Unidos, sem burocracia e com total transparência.
            </p>
            
            <p className="text-lg text-gray-200 leading-relaxed mb-6">
              Sabemos que importar pode parecer intimidador no começo, e é exatamente por isso que estamos aqui: para te acompanhar em cada passo dessa jornada. Nossa equipe trabalha todos os dias com um único objetivo: <strong className="text-indigo-400">fazer você se sentir seguro e bem cuidado</strong>.
            </p>

            <p className="text-lg text-gray-200 leading-relaxed">
              Quando você escolhe a Steel, você não está apenas contratando um serviço - você está entrando para uma comunidade de pessoas que priorizam qualidade com preço justo e, o principal, <strong className="text-indigo-400">SEGURANÇA!</strong> 💙
            </p>
          </div>
        </div>

        {/* Image Carousel - Centralizado */}
        <div className="flex justify-center">
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-4 shadow-2xl relative overflow-hidden max-w-sm w-full">
            <div className="relative w-full" style={{ aspectRatio: '9/16' }}>
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Equipe Steel Importações ${index + 1}`}
                  className={`absolute top-0 left-0 w-full h-full object-cover rounded-2xl shadow-lg transition-all duration-1000 ease-in-out ${
                    index === currentImageIndex
                      ? 'opacity-100 translate-x-0'
                      : index < currentImageIndex
                      ? 'opacity-0 -translate-x-full'
                      : 'opacity-0 translate-x-full'
                  }`}
                />
              ))}
            </div>

            {/* Carousel Indicators */}
            <div className="flex justify-center gap-2 mt-4">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImageIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    index === currentImageIndex
                      ? 'bg-indigo-400 w-8'
                      : 'bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Ir para imagem ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
